var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { Consumer } from '../components/Map';

/**
 * Provides wrapped components rendered in the component tree below Map with props for accessing the ol/Map, determining map resolution and obtaining a BAAT token.
 *
 * **Note: Wrapped components will not be rendered until the map is available.**
 *
 * This is typically used to create components that manipulate or add features to the map. Examples includes most components in this package.
 *
 * This HOC makes it possible to implement own components that provide map functionality.
 *
 * @component
 */
export function ensureMap(WrappedComponent) {
  var MapConsumer = function (_React$Component) {
    _inherits(MapConsumer, _React$Component);

    function MapConsumer() {
      _classCallCheck(this, MapConsumer);

      return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    MapConsumer.prototype.render = function render() {
      var _this2 = this;

      return React.createElement(
        Consumer,
        null,
        function (mapContext) {
          if (!mapContext.map) return;
          return React.createElement(WrappedComponent, _extends({
            map: mapContext.map,
            getResolution: mapContext.getResolution,
            baatToken: mapContext.baatToken
          }, _this2.props));
        }
      );
    };

    return MapConsumer;
  }(React.Component);

  return MapConsumer;
}